<template>
    <div>
      <avue-crud
      ref="crud"
      v-model="form"
        :option="option"
        :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
        @current-change="currentChange"
        @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
        >
          <template slot="menuLeft">
            <el-upload
              class="inline-upload"
              action=""
              accept=".xls,.xlsx"
              :show-file-list="false"
              :http-request="handleImport"
            >
              <el-button
                type="primary"
                size="small"
                icon="el-icon-upload2"
                plain
                :loading="importLoading"
              >
                导入
              </el-button>
            </el-upload>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              plain
              :loading="exportLoading"
              @click="handleExport"
            >
              导出
            </el-button>
            <el-button
              type="default"
              size="small"
              icon="el-icon-document"
              plain
              :loading="templateLoading"
              @click="handleDownloadImportTemplate"
            >
              导入模板
            </el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
          plain
          :disabled="selectionList.length == 0"
              @click="handleDelete"
        >
          批量删除
            </el-button>
          </template>
        </avue-crud>
    </div>
  </template>
  
  <script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, removeBatch, downloadImportTemplate, exportExcel, importExcel } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
import { downloadXls } from "@/util/util";
  
  export default {
  mixins: [crudMixins],
    data() {
    const that = this;
      return {
      form: {},
      importLoading: false,
      exportLoading: false,
      templateLoading: false,
      apiConfig: { getList, add, update, remove, getDetail, batchRemove: removeBatch },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: true,
        column: [
          {
            label: "专家编号",
            prop: "expertNo",
            overHidden: true,
            minWidth: 150,
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "专家姓名",
            prop: "expertName",
            overHidden: true,
            minWidth: 120,
            maxlength: 50,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: "性别",
            prop: "gender",
            search: true,
            overHidden: true,
            width: 80,
            type: "select",
            dicData: [
              { label: "男", value: 1 },
              { label: "女", value: 2 },
            ],
            rules: rulesInput(2),
          },
          {
            label: "联系电话",
            prop: "phone",
            overHidden: true,
            width: 130,
            maxlength: 20,
            search: true,
            placeholder: "请输入联系电话",
            rules: [
              { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
            ],
          },
          {
            label: "出生日期",
            prop: "birthDate",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            overHidden: true,
            width: 120,
            pickerOptions: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            rules: rulesInput(2),
          },
          {
            label: "级别类型",
            prop: "levelType",
            search: true,
            overHidden: true,
            width: 120,
            type: "select",
            dicData: [
              { label: "国家级", value: "国家级" },
              { label: "省级", value: "省级" },
              { label: "市级", value: "市级" },
              { label: "县级", value: "县级" },
              { label: "其他", value: "其他" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "领域",
            prop: "domain",
            search: true,
            overHidden: true,
            width: 120,
            type: "select",
            dicData: [
              { label: "医疗", value: "医疗" },
              { label: "消防", value: "消防" },
              { label: "救援", value: "救援" },
              { label: "通讯", value: "通讯" },
              { label: "交通", value: "交通" },
              { label: "环保", value: "环保" },
              { label: "其他", value: "其他" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "专业方向",
            prop: "majorDirection",
            overHidden: true,
            minWidth: 120,
            maxlength: 100,
            search: true,
            placeholder: "请输入专业方向",
            rules: rulesInput(2),
          },
          {
            label: "专长",
            prop: "expertise",
            overHidden: true,
            minWidth: 150,
            maxlength: 200,
            placeholder: "请输入专长",
            rules: rulesInput(2),
          },
          {
            label: "职称",
            prop: "professionalTitle",
            search: true,
            overHidden: true,
            width: 120,
            type: "select",
            dicData: [
              { label: "主任医师", value: "主任医师" },
              { label: "副主任医师", value: "副主任医师" },
              { label: "主治医师", value: "主治医师" },
              { label: "医师", value: "医师" },
              { label: "高级工程师", value: "高级工程师" },
              { label: "工程师", value: "工程师" },
              { label: "其他", value: "其他" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "最高学历",
            prop: "highestEducation",
            search: true,
            overHidden: true,
            width: 120,
            type: "select",
            dicData: [
              { label: "博士", value: "博士" },
              { label: "硕士", value: "硕士" },
              { label: "本科", value: "本科" },
              { label: "专科", value: "专科" },
              { label: "其他", value: "其他" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "工作单位",
            prop: "workUnit",
            overHidden: true,
            minWidth: 150,
            maxlength: 200,
            search: true,
            placeholder: "请输入工作单位",
            rules: rulesInput(2),
          },
          {
            label: "职务",
            prop: "position",
            overHidden: true,
            width: 120,
            maxlength: 100,
            placeholder: "请输入职务",
            rules: rulesInput(2),
          },
          {
            label: "邮箱",
            prop: "email",
            overHidden: true,
            width: 180,
            maxlength: 100,
            placeholder: "请输入邮箱",
            rules: [
              { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
            ],
          },
          {
            label: "通讯地址",
            prop: "address",
            overHidden: true,
            minWidth: 200,
            maxlength: 200,
            placeholder: "请输入通讯地址",
            rules: rulesInput(2),
          },
          {
            label: "身份证号",
            prop: "idCard",
            overHidden: true,
            width: 180,
            maxlength: 18,
            search: true,
            placeholder: "请输入身份证号",
            rules: [
              { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: "请输入正确的身份证号", trigger: "blur" }
            ],
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            overHidden: true,
            width: 100,
            dicData: [
              { label: "无效", value: 0 },
              { label: "有效", value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            maxlength: 500,
            span: 24,
            minRows: 3,
            hide: true,
            placeholder: "请输入备注",
          },
          {
            label: "录入人",
            prop: "createName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig("录入时间", { type: "datetimerange" }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "修改人",
            prop: "updateName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ],
      },
      defaultParams: {},
    };
  },
  methods: {
    async handleImport({ file }) {
      if (!file) {
        return;
      }
      const fileName = file.name || "";
      if (!/\.(xls|xlsx)$/i.test(fileName)) {
        this.$message.error("仅支持 xls、xlsx 文件");
        return;
      }
      this.importLoading = true;
      try {
        const res = await importExcel(file);
        this.showImportResult(res && res.data);
        this.onLoad(this.page, this.query);
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导入失败");
      } finally {
        this.importLoading = false;
      }
    },
    showImportResult(data) {
      const result = (data && data.data) || {};
      if (result && typeof result === "object" && (result.failCount > 0 || result.successCount >= 0)) {
        const successCount = result.successCount || 0;
        const failCount = result.failCount || 0;
        if (failCount > 0) {
          const errors = (result.errors || []).slice(0, 5).map(item => `第${item.rowNum}行：${item.message}`).join("\n");
          this.$alert(errors || "存在导入失败数据", `导入完成：成功${successCount}条，失败${failCount}条`, {
            type: successCount > 0 ? "warning" : "error",
          });
          return;
        }
        this.$message.success(`导入成功，共${successCount}条`);
        return;
      }
      this.$message.success((data && (data.msg || data.data)) || "导入成功");
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `应急专家_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    async handleDownloadImportTemplate() {
      this.templateLoading = true;
      try {
        const res = await downloadImportTemplate();
        downloadXls(res.data, `应急专家导入模板_${Date.now()}.xlsx`);
        this.$message.success("模板下载成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "模板下载失败");
      } finally {
        this.templateLoading = false;
      }
    },
    // 扩展beforeOpen，处理详情获取
    beforeOpen(done, type) {
      // 调用crudMixins的beforeOpen
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data;
          done();
        });
      } else {
        done();
      }
    },
    // 扩展rowSave，处理新增
    rowSave(row, done, loading) {
      // 设置默认状态
      if (row.status === undefined || row.status === null) {
        row.status = 1;
      }
      // 调用父类方法
      this.apiConfig.add(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
    // 扩展rowUpdate，处理更新
    rowUpdate(row, index, done, loading) {
      // 调用父类方法
      this.apiConfig.update(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
  },
};
  </script>

<style scoped lang="scss">
p {
  margin: 0;
}

.inline-upload {
  display: inline-block;
  margin-right: 8px;
}
</style>
